import { BrowserRouter, Navigate, Routes, Route, useLocation } from "react-router-dom";
import AccessPage from "@/pages/AccessPage";
import AdminPage from "@/pages/AdminPage";
import ManageTeamPage from "@/pages/ManageTeamPage";
import { NavBar } from "@/components/NavBar";
import { Toaster } from "@/components/ui/sonner";

function AppShell() {
  const { pathname } = useLocation();
  const isManageTeam = pathname.startsWith("/manage-team");
  return (
    <>
      {!isManageTeam && <NavBar />}
      <Routes>
        <Route path="/" element={<Navigate to="/access" replace />} />
        <Route path="/access" element={<AccessPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/manage-team/:productId" element={<ManageTeamPage />} />
        <Route
          path="*"
          element={
            <div className="mx-auto max-w-2xl px-6 py-16 text-center">
              <h1 className="text-2xl font-semibold">Page not found</h1>
              <p className="mt-2 text-sm text-muted-foreground">
                The page you are looking for does not exist.
              </p>
            </div>
          }
        />
      </Routes>
      <Toaster />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
